module.exports = __webpack_public_path__ + "aed665b8d0ddb55a1363c1f5ad730c93.MP3";